import VoicemailMenu from './VoicemailMenu';
import VoicemailDetailslist from './VoicemailDetailslist';

const VoicemailWidgets = () => {
    return (
        <div className="main-content">
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-2'>
                        <VoicemailMenu />
                    </div>
                    <div className='col-md-10'>
                        <VoicemailDetailslist />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default VoicemailWidgets;
